import { useTranslation } from "react-i18next";

import type { ID } from "@constants";
import { showActionAlert } from "@components/molecules/alert";
import { useConvertDate } from "@utils";
import { AppointmentComment } from "@components/organisms/appointmentCard";

export const useCommentAppointmentFunc = (id: ID) => {
  const { t } = useTranslation("form");

  const { humanizeFullDate } = useConvertDate();

  return (date: Date | string, doctorName: string) =>
    showActionAlert({
      title: t("doctor_comment"),
      content: t("doctor_comment_box", {
        date: humanizeFullDate(date),
        doctor: doctorName,
      }),
      noButtons: true,
      children: <AppointmentComment id={id} />,
    });
};
